export enum Entity {
  Workout = 'Workout',
  Series = 'Series',
}
